/* Aloe Jewels – chain guide dialog (snippets/aj-chain-guide.liquid). Display only. */
(() => {
  if (customElements.get('aj-chain-guide')) return;

  class AjChainGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('.aj-chain-guide__open');
      if (!this.dialog || !this.openButton) return;

      // The dialog is moved to <body> so it is never clipped by the sticky product column
      document.body.appendChild(this.dialog);

      // Swipe indicator for the three-chain row on phones: the thumb's width and position follow the scroll
      this.row = this.dialog.querySelector('.aj-chain-guide__chains--3');
      this.thumb = this.dialog.querySelector('.aj-chain-guide__scroll-thumb');
      this.onScroll = () => {
        if (!this.row || !this.thumb) return;
        const visible = this.row.clientWidth / this.row.scrollWidth;
        const max = this.row.scrollWidth - this.row.clientWidth;
        const progress = max > 0 ? this.row.scrollLeft / max : 0;
        this.thumb.style.width = Math.min(100, visible * 100) + '%';
        this.thumb.style.transform = 'translateX(' + (progress * (1 - visible) / visible * 100) + '%)';
      };

      this.onOpen = () => {
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        if (this.row) { this.row.scrollLeft = 0; this.onScroll(); }
      };
      this.onClose = () => { document.documentElement.style.overflow = ''; this.openButton.focus({ preventScroll: true }); };
      // Close on the × button or when tapping the dark backdrop
      this.onClick = (event) => {
        if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
      };

      this.openButton.addEventListener('click', this.onOpen);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('click', this.onClick);
      if (this.row) this.row.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      if (!this.dialog) return;
      this.openButton.removeEventListener('click', this.onOpen);
      this.dialog.removeEventListener('close', this.onClose);
      this.dialog.removeEventListener('click', this.onClick);
      if (this.row) this.row.removeEventListener('scroll', this.onScroll);
      this.dialog.remove();
    }
  }

  customElements.define('aj-chain-guide', AjChainGuide);
})();
